export const PatternsCard = {
    13: [4,3,2,4],
    15: [4,6,5],
    16: [4,4,4,4],
    18: [9,9],
    19: [4,4,4,4,3]
}